import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=18f6d8aa&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=18f6d8aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f6d8aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18f6d8aa')) {
      api.createRecord('18f6d8aa', component.options)
    } else {
      api.reload('18f6d8aa', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=18f6d8aa&scoped=true&", function () {
      api.rerender('18f6d8aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2s2vMko5176rw/JS/comp/PopupDialog.vue"
export default component.exports